import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { ModalLoginComponent } from "./modal-login.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormularioLoginModule } from "../formulario-login/formulario-login.module";

@NgModule({
  imports: [
    BrowserModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    FormularioLoginModule,
  ],
  declarations: [ModalLoginComponent],
  exports: [ModalLoginComponent],
  bootstrap: [ModalLoginComponent],
})
export class ModalLoginModule {}
